module.exports = __webpack_public_path__ + "img/trip-duration.bf4c7a58.svg";